import {
    CANCEL_REQUEST_OPERATION,
    DELETE_GOOGLE_CREDENTIALS_OPERATION,
    SET_GOOGLE_CREDENTIALS_OPERATION
} from 'app/store/__generated__/operations';
import {
    GET_GOOGLE_CREDENTIALS,
    SET_GOOGLE_CREDENTIALS,
    DELETE_GOOGLE_CREDENTIALS,
    CANCEL_QUERY,
    TOGGLE_INTEGRATION_UNCONFIGURED_DIALOG
} from './types.js';

export const doToggleIntegrationUnconfiguredDialog = (isOpen) => ({
    type: TOGGLE_INTEGRATION_UNCONFIGURED_DIALOG,
    isOpen
});

export const doGetGoogleCredentials = () => ({
    type: GET_GOOGLE_CREDENTIALS,
    api: { version: 2, name: 'GetGoogleCredentialsInfo' }
});

export const doDeleteGoogleCredentials = (googleCredentials) => ({
    type: DELETE_GOOGLE_CREDENTIALS,
    api: DELETE_GOOGLE_CREDENTIALS_OPERATION,
    params: {
        googleCredentials
    }
});

export const doSetGoogleCredentials = (googleCredentials) => ({
    type: SET_GOOGLE_CREDENTIALS,
    api: SET_GOOGLE_CREDENTIALS_OPERATION,
    params: {
        googleCredentials
    },
    onSucceeded: ({ dispatch }) => {
        dispatch(doGetGoogleCredentials());
    }
});

export const doCancelQuery = ({ requestId }) => ({
    type: CANCEL_QUERY,
    api: CANCEL_REQUEST_OPERATION,
    params: { requestId }
});
